module.exports = __webpack_public_path__ + "static/fonts/ziemann-icons.37f18046.svg";